const getArgumentIndex = (defKey, valueKey) => {
  const defKeyParts = defKey.split('.');
  const valueKeyParts = valueKey.split('.').slice(0, defKeyParts.length);

  for (let i = 0; i < defKeyParts.length; i++) {
    if (i < defKeyParts.length - 1) {
      const a = defKeyParts[i];
      const b = valueKeyParts[i];
      if (a !== b) {
        return -1;
      }
      continue;
    }

    const a = defKeyParts[i];
    const b = valueKeyParts[i]?.replace(/\[\d+\]$/, '[]');
    if (a !== b) {
      return -1;
    }
  }
  const number = parseInt(valueKeyParts[valueKeyParts?.length - 1].match(/\[(\d+)\]$/)?.[1], 10);
  return !isNaN(number) ? number : -1;
};

const getLastArrayStepArgumentIndex = (arg, stepArgs) => {
  let max = -1;

  for (const stepArgKey in stepArgs) {
    const index = getArgumentIndex(arg.key, stepArgKey);
    max = Math.max(max, index);
  }

  return max;
};

export default getLastArrayStepArgumentIndex;
